// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__uyPmv","addWidgetButton":"Header_addWidgetButton__kxMki","dashboardTabs":"Header_dashboardTabs__2N-ae","active":"Header_active__BMBGy"};